import { FC } from 'react';
import { QRCodeCanvas } from 'qrcode.react';

interface QrGeneratorProps {
  url: string;
}

const QrGenerator: FC<QrGeneratorProps> = ({ url }) => {
  return (
    <div className="flex flex-col items-center gap-4">
      <QRCodeCanvas
        value={url}
        size={200}
        bgColor="#ffffff"
        fgColor="#000000"
        level="H"
      />
    </div>
  );
};

export default QrGenerator;
